// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14cyG","label":"styles_label__1NOW5"};